<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>校务管理 / 教师管理</span>
      </div>
      <div class="search-container">
        <el-row class="search-row" style="margin-left: 0; margin-right: 0;" :gutter="24">
          <el-col :span="5">
            <el-select v-model="status" placeholder="账号状态" clearable>
              <el-option
                v-for="item in statuses"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input v-model.trim="name" placeholder="姓名 / 手机号" clearable></el-input>
          </el-col>
          <el-col :span="4" style="text-align: center;">
            <el-button type="primary" size="medium" @click="initTeacher(1)">查询</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="table-container scroll">
        <el-row>
          <el-col :span="24">
            <el-button type="primary" size="medium" :disabled="$regional.disableCRUD" @click="handleAdd">添加教师</el-button>
            <el-button type="primary" plain size="medium" :disabled="$regional.disableCRUD" @click="handleImport">导入</el-button>
            <el-button type="primary" plain size="medium" @click="handleExport">导出</el-button>
          </el-col>
        </el-row>
        <el-row class="table">
          <el-col :span="24">
            <el-table :data="pageData.t2" size="medium" :row-class-name="isRowAailable">
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="phone" label="手机号"></el-table-column>
              <el-table-column prop="certificate" label="证件类型">
                <template slot-scope="scope">
                  <span>{{_.filter(idTypes, { 'value': scope.row.certificate })[0].name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="certificateNo" min-width="120" label="证件号码"></el-table-column>
              <el-table-column label="账号状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.available" style="color: #2DC16E;">● 正常</span>
                  <span v-else style="color: #FF6C6B;">● 冻结</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" :disabled="!scope.row.available || $regional.disableCRUD" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button
                    type="text"
                    @click="handleDisable(scope.$index, scope.row)"
                  >{{scope.row.available ? '停用' : '启用'}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row class="zyyj-pagination-row">
          <el-col :span="24">
            <el-pagination
              :total="pageData.t1"
              :current-page.sync="page"
              :page-sizes="[20, 50, 100]"
              :page-size.sync="size"
              background
              layout="total, sizes, prev, pager, next"
              @current-change="initTeacher"
              @size-change="handleSizeChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>

    <teacher-edit-box
      :visible.sync="editorVisible"
      :identify="teacherInfo"
      @edit-result="initTeacher(page)"
    ></teacher-edit-box>

    <excel-importer-box
      topic="人"
      action="/acc/teachers/import"
      template="/acc/teachers/templates"
      errorUrl="/acc/teachers/fail/export"
      type="教师"
      :visible.sync="importDialogVisible"
      @import-result="initTeacher(page)"
    >
      <template slot="if-failure">
        <el-table-column prop="objectName" label="教师姓名" width="150"></el-table-column>
        <el-table-column prop="rowNum" label="所在行" width="100"></el-table-column>
        <el-table-column prop="errorMessageList" label="导入失败原因">
          <template slot-scope="scope">
            <span v-for="(msg, index) in scope.row.errorMessageList" :key="msg">
              <span>{{msg}}</span>
              <span v-if="index !== scope.row.errorMessageList.length - 1">、</span>
            </span>
          </template>
        </el-table-column>
      </template>
    </excel-importer-box>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import TeacherEditor from '@/components/school-admin/affair/TeacherEditor'
import ExcelImporterBox from '@/components/common/ExcelImporterBox'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    'teacher-edit-box': TeacherEditor,
    'excel-importer-box': ExcelImporterBox
  },

  data () {
    return {
      pageData: {},
      size: 0,
      page: 1,
      editorVisible: false,
      teacherInfo: {},
      status: '',
      statuses: [
        {
          name: '正常',
          value: 1
        },
        {
          name: '冻结',
          value: 0
        }
      ],
      name: '',
      idTypes: [
        {
          name: '居民身份证',
          value: 1
        },
        {
          name: '香港特区护照／身份证明',
          value: 2
        },
        {
          name: '澳门特区护照／身份证明',
          value: 3
        },
        {
          name: '台湾居民来往大陆身份证明',
          value: 4
        },
        {
          name: '外籍护照',
          value: 5
        }
      ],
      importDialogVisible: false
    }
  },

  watch: {

  },

  computed: {
    _ () {
      return _
    }
  },

  mounted () {
    this.initTeacher()
  },

  methods: {
    initTeacher (page) {
      if (page) {
        this.page = page
      }
      let queryParam = {
        available: this.status,
        name: this.name,
        size: this.size ? this.size : 20,
        page: this.page
      }
      this.$xhrGet(`/acc/teachers`, queryParam).then(rs => {
        this.pageData = rs.data
      })
    },

    handleSizeChange (val) {
      this.size = val
      this.page = 1
      let queryParam = {
        available: this.status,
        name: this.name,
        size: this.size,
        page: this.page
      }
      this.$xhrGet(`/acc/teachers`, queryParam).then(rs => {
        this.pageData = rs.data
      })
    },

    handleAdd () {
      this.editorVisible = true
      this.teacherInfo = {}
    },

    handleImport () {
      this.importDialogVisible = true
    },

    handleExport () {
      this.$fetchFile(`/acc/teachers/export`, { name: `${this.$store.state.user.school}教师表` })
    },

    handleEdit (index, row) {
      this.editorVisible = true
      this.teacherInfo = row
    },

    handleDisable (index, row) {
      this.$xhrPatch(`/acc/teachers/${row.id}`, { available: !row.available }).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initTeacher()
        } else if (rs.code === 403) {
          this.$message.success('')
        }
      })
    },

    isRowAailable ({ row, rowIndex }) {
      return 'zyyj-row-available-' + row.available
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.search-container {
  width: calc(100% - 80px);
  height: 76px;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.search-row {
  height: 100%;
  padding: 20px;
  background: #f9f9f9;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 264px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.table {
  margin-top: 40px;
}
/deep/ .el-input__inner {
  height: 36px;
}
/deep/ .el-button--primary.is-plain {
  background: transparent;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: var(--theme-color);
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/TeacherManage.vue